<!--
 * @Description: 
 * @Date: 2021-01-15 11:54:31
-->
<script>
import { moneyFixed, transScale } from '@/tools/money.js';
export default {
  // functional: true,
  props: ['title', 'list'],
  name: 'rateList', // 费率列表
  render: function(h) {
    let _this = this;
    if (!this.title) {
      return h('span', '-');
    }
    return (
      <div
        style={{ display: 'flex', position: 'relative', alignItems: 'center' }}
      >
        <div class="ellipsis">{_this.title}</div>

        {this.list && (
          <el-popover trigger="hover" placement="right">
            <div class="rateList">
              <table border="0" cellSpacing="0">
                <thead style={{ textAlign: 'center' }}>
                  <tr>
                    <th class="fz16 t-title fw500" colSpan="2">
                      {_this.title}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>服务费发放区间（自然人）</td>
                    <td>服务费率（%）</td>
                  </tr>
                  {_this.list &&
                    _this.list.map(i => (
                      <tr class="fz12 t-primary">
                        <td>
                          {moneyFixed(+i.startPrice)} -{' '}
                          {moneyFixed(+i.endPrice)}
                        </td>
                        <td>{transScale(i.sumScale)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <el-button
              slot="reference"
              size="medium"
              type="text"
              icon="el-icon-warning"
            ></el-button>
          </el-popover>
        )}
      </div>
    );
  }
};
</script>
<style lang="scss">
.rateList {
  table {
    th {
      border-bottom: 0.5px solid #c1c1cc;
    }
    th,
    td {
      padding: 8px 24px;
    }
    tr:not(:last-child) > td {
      border-bottom: 0.5px solid #c1c1cc;
      // text-align: center;
    }
  }
}
</style>
